import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { ActivatedRoute } from '@angular/router'
import { saveAs } from 'file-saver'

import { environment } from '../../../../../environments/environment'
import { ShoppingCartService } from '../../cart-shared/cart.service'
import { DatePipe } from '@angular/common'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { SavedCartService } from '../saved-cart.service'
import { filter, take } from 'rxjs/operators'
import { CommonService } from '../../../../shared/services/common.service'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-saved-cart-detail',
  templateUrl: './saved-cart-detail.component.html',
  styleUrls: ['./saved-cart-detail.component.scss'],
})
export class SavedCartDetailComponent implements OnInit {
  currentUser
  currentCart
  savedCartId
  public apiurl = environment.occBaseUrl
  displayedColumns = ['index', 'product', 'quantity', 'price', 'total']
  dataSource = []
  displayMaxSavedCartErrorMsg: boolean = false
  currentDate: Date
  sharedCart: any
  sharedTextFlag: boolean
  quoteTextFlag: boolean
  constructor(
    private commonService: CommonService,
    private launchDialogService: LaunchDialogService,
    private route: ActivatedRoute,
    private cartService: ShoppingCartService,
    private breadCrumbService: BreadcrumbService,
    private globalMessageService: GlobalMessageService,
    private datepipe: DatePipe,
    private translate: TranslationService,
    private savedCartService: SavedCartService
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.sharedCart = params
    })

    if (this.sharedCart.sharedCart == 'true') {
      this.sharedTextFlag = true
    } else if (this.sharedCart.sharedCart == 'false') {
      this.sharedTextFlag = false
    }
    if (this.sharedCart.quoteCart == 'true') {
      this.quoteTextFlag = true
    } else if (this.sharedCart.quoteCart == 'false') {
      this.quoteTextFlag = false
    }
    this.translate.translate('savedCart.mySavedCart').subscribe((res: string) =>
      this.breadCrumbService.setBreadCrumbs([
        {
          label: res,
          link: '/saved-carts',
        },
      ])
    )

    this.translate
      .translate('savedCart.mySavedCartDetails')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.savedCartId = this.route.snapshot.paramMap.get('savedCartId')
    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
        this.loadCartData()
      },
      (err) => {
        this.globalMessageService.add(
          {
            key: 'savedCart.idNotFound',
            params: {
              errorMsgJson: err.message,
            },
          },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )

    this.savedCartService.maxSavedCartErrorNotification.subscribe(
      (data) => {
        this.displayMaxSavedCartErrorMsg = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  loadCartData() {
    if (!this.currentUser.uid || !this.savedCartId) {
      return
    }

    let url
    if (this.sharedCart.sharedCart == 'false') {
      url = this.commonService.constructUrl([
        'users',
        this.currentUser.uid,
        'carts',
        this.savedCartId,
        'savedcart',
      ])
    } else if (this.sharedCart.sharedCart == 'true') {
      url = this.commonService.constructUrl([
        'users',
        this.currentUser.uid,
        this.savedCartId,
        'sharedCartDetails',
      ])
    }

    this.commonService.getData(url).subscribe(
      (data: any) => {
        this.currentCart = data.savedCartData
        let date: any = new Date()
        let expiryDate: any = new Date(this.currentCart.expirationTime)
        let diffDate = Math.floor((expiryDate - date) / (1000 * 60 * 60 * 24))
        if (diffDate <= this.currentCart.savedCartDaysToExpire) {
          this.currentCart.showWarning = true
        } else {
          this.currentCart.showWarning = false
        }
        if (
          this.currentCart &&
          this.currentCart.entries &&
          this.currentCart.entries.length
        ) {
          this.dataSource = this.currentCart.entries.map((entry, i) => {
            entry.index = i + 1
            return entry
          })
        } else {
        }
      },
      (err) => {
        this.globalMessageService.add(
          {
            key: 'savedCart.noCartsFound',
            params: {
              errorMsgJson: err.message,
            },
          },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  isExpiring(expiryDate: any, daysToExpire: any) {
    const date1 = new Date()
    const date2 = new Date(expiryDate)
    const diffTime = Math.abs(date2.getTime() - date1.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    if (diffDays <= daysToExpire) {
      return true
    }
    return false
  }

  deleteSavedCart(element) {
    this.openDeleteModal(element)
  }

  private openDeleteModal(element) {
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
    }

    const deleteSavedCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.DELETE_SAVED_CART,
      undefined,
      undefined,
      componentdata
    )
    if (deleteSavedCartDialog) {
      deleteSavedCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.DELETE_SAVED_CART
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.deleteSuccess) {
            this.loadCartData()
          }
        })
    }
  }

  restoreSavedCart(element) {
    this.openRestoreModal(element)
  }

  private openRestoreModal(element) {
    if (this.sharedCart.quoteCart == 'false') {
      const componentdata = {
        currentCart: element,
        currentUser: this.currentUser,
        sharedCartFlag: this.sharedCart.sharedCart,
        quoteCartFlag: this.sharedCart.quoteCart,
      }

      const restoreSavedCartDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.RESTORE_SAVED_CART,
        undefined,
        undefined,
        componentdata
      )
      if (restoreSavedCartDialog) {
        restoreSavedCartDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose.subscribe((value) => {})
      }
    } else if (this.sharedCart.quoteCart == 'true') {
      const componentdata = {
        currentCart: element,
        currentUser: this.currentUser,
        sharedCartFlag: this.sharedCart.sharedCart,
        quoteCartFlag: this.sharedCart.quoteCart,
      }

      const restoreSavedQuoteCartDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.RESTORE_SAVED_QUOTE_CART,
        undefined,
        undefined,
        componentdata
      )
      if (restoreSavedQuoteCartDialog) {
        restoreSavedQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose.subscribe((value) => {})
      }
    }
  }

  extendExpiry(element) {
    this.extendExpiryModal(element)
  }

  private extendExpiryModal(element) {
    window.scrollTo(0, 0)
    const componentdata = {
      currentCart: element,
      currentUser: this.currentUser,
    }

    const extendExpiryDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY,
      undefined,
      undefined,
      componentdata
    )
    if (extendExpiryDialog) {
      extendExpiryDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.data?.extendedExpiry) {
            this.loadCartData()
          }
        })
    }
  }
  downloadSaveCart() {
    if (!this.currentUser.uid || !this.savedCartId) {
      return
    }
    if (this.sharedCart.quoteCart == 'true') {
      this.cartService
        .exportQuoteCart(this.currentUser.uid, this.savedCartId)
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined) {
              const currentDate = this.datepipe.transform(
                new Date(),
                'yyyyMMdd'
              )
              let fileName = this.currentCart.name + currentDate
              const blob = new Blob([res], { type: 'application/vnd.ms.excel' })
              const file = new File([blob], fileName + '.xlsx', {
                type: 'application/vnd.ms.excel',
              })
              saveAs(file)
            } else {
              this.displayDownloadError()
            }
          },
          (error) => {
            this.displayDownloadError()
          }
        )
    } else if (this.sharedCart.quoteCart == 'false') {
      this.cartService
        .exportBuyCart(this.currentUser.uid, this.savedCartId)
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined) {
              const currentDate = this.datepipe.transform(
                new Date(),
                'yyyyMMdd'
              )
              let fileName = this.currentCart.name + currentDate
              const blob = new Blob([res], { type: 'application/vnd.ms.excel' })
              const file = new File([blob], fileName + '.xlsx', {
                type: 'application/vnd.ms.excel',
              })
              saveAs(file)
            } else {
              this.displayDownloadError()
            }
          },
          (error) => {
            this.displayDownloadError()
          }
        )
    }
  }
  displayDownloadError() {
    this.globalMessageService.add(
      { key: 'savedCart.issueDownloadingXlsx' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }
}
